/* ========================================================================
   Carousels
 ========================================================================== */

app.carousel = (function () {
  'use strict';

  function init() {
    document.querySelectorAll('[data-carousel]').forEach((section) => {
      initGeneric(section);
    });

    document.querySelectorAll('[data-hero-carousel]').forEach((section) => {
      initHeroCarousel(section);
    });

    document.querySelectorAll('[data-logo-carousel]').forEach((section) => {
      initLogoCarousel(section);
    });

    document.querySelectorAll('[data-tabs-carousel]').forEach((section) => {
      initTabsCarousel(section);
    });
  }

  function initGeneric(section) {
    const viewport = section.querySelector('[data-carousel-viewport]');
    const prevBtn = section.querySelector('[data-carousel-prev]');
    const nextBtn = section.querySelector('[data-carousel-next]');
    const items = section.querySelectorAll('[data-carousel-item]');

    //
    // Init carousel
    //

    let startIndex = 0;

    if (viewport.dataset.startIndex) {
      startIndex = parseInt(viewport.dataset.startIndex);
    }

    const carousel = new EmblaCarousel(viewport, {
      inViewThreshold: 0.1,
      align: 'start',
      containScroll: 'trimSnaps',
      startIndex: startIndex,
      breakpoints: {
        '(min-width: 992px)': { draggable: false },
      },
    });

    //
    // Event listeners
    //

    carousel.on('init', (event) => {
      app.embla.onInit(prevBtn, nextBtn, viewport, carousel);
    });

    carousel.on('reInit', (event) => {
      app.embla.onReInit(prevBtn, nextBtn, carousel);
    });

    carousel.on('select', (event) => {
      app.embla.onSelect(prevBtn, nextBtn, carousel);
    });

    carousel.on('settle', (event) => {
      app.embla.onSettle(carousel);
    });
  }

  function initHeroCarousel(section) {
    const viewport = section.querySelector('[data-carousel-viewport]');
    const dots = section.querySelector('[data-carousel-dots]');
    const items = section.querySelectorAll('[data-carousel-item]');

    //
    // Init carousel
    //

    let startIndex = 0;

    if (viewport.dataset.startIndex) {
      startIndex = parseInt(viewport.dataset.startIndex);
    }

    const emblaOptions = {
      inViewThreshold: 0.1,
      align: 'start',
      containScroll: 'trimSnaps',
      loop: false,
      breakpoints: {
        '(min-width: 992px)': { draggable: false },
      },
    };

    const carousel = new EmblaCarousel(viewport, emblaOptions);
    const dotsArray = app.embla.generateDots(dots, carousel);

    const reInit = util.debounce(() => {
      carousel.scrollTo(0, true);
    });

    app.embla.initDots(dotsArray, carousel);

    dotsArray.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        // DATALAYER
        app.dataLayer.pushEvent('heroCarouselPager', {
          pageUrl: window.location.pathname,
          slide: index + 1,
        });
      });
    });

    //
    // Event listeners
    //

    carousel.on('init', (event) => {
      app.embla.onInit(null, null, viewport, carousel);
      app.embla.selectDot(dotsArray, carousel);
    });

    carousel.on('reInit', (event) => {
      app.embla.onReInit(null, null, carousel);
      app.embla.selectDot(dotsArray, carousel);
      reInit();
    });

    carousel.on('select', (event) => {
      app.embla.onSelect(null, null, carousel);
      app.embla.selectDot(dotsArray, carousel);
    });

    carousel.on('settle', (event) => {
      app.embla.onSettle(carousel);
    });
  }

  function initLogoCarousel(section) {
    const viewport = section.querySelector('[data-carousel-viewport]');
    const items = section.querySelectorAll('[data-carousel-item]');

    //
    // Init carousels
    //

    const emblaOptions = {
      inViewThreshold: 0.1,
      align: 'start',
      containScroll: 'trimSnaps',
      loop: true,
      breakpoints: {
        '(min-width: 992px)': { draggable: false },
      },
    };

    const autoPlay = EmblaAutoplay(
      { delay: 3000, stopOnInteraction: false, stopOnMouseEnter: true },
      (emblaRoot) => emblaRoot.parentElement
    );

    const carousel = new EmblaCarousel(viewport, emblaOptions, [autoPlay]);

    //
    // Event listeners
    //

    carousel.on('init', (event) => {
      viewport.classList.add('is-initialized');
    });
  }

  function initTabsCarousel(section) {
    const viewport = section.querySelector('[data-carousel-viewport]');
    const prevBtn = section.querySelector('[data-carousel-prev]');
    const nextBtn = section.querySelector('[data-carousel-next]');
    const buttons = document.querySelectorAll('[data-tab-button="' + section.id + '"]');

    //
    // Init carousel
    //

    let startIndex = 0;

    const buttonHandler = function (event) {
      event.preventDefault();

      if (event.target.classList.contains('is-selected')) return;

      const slideIndex = parseInt(event.target.dataset.slideIndex);
      updateButtons(slideIndex);

      event.target.classList.add('is-selected');
      carousel.scrollTo(slideIndex);
    };

    const updateButtons = function (slideIndex) {
      buttons.forEach((button) => {
        if (button.dataset.slideIndex == slideIndex) {
          button.classList.add('is-selected');
        } else {
          button.classList.remove('is-selected');
        }
      });
    };

    if (viewport.dataset.startIndex) {
      startIndex = parseInt(viewport.dataset.startIndex);
    }

    const options = {
      inViewThreshold: 0.1,
      align: 'start',
      containScroll: 'trimSnaps',
      startIndex: startIndex,
      breakpoints: {
        '(min-width: 768px)': { draggable: false },
      },
    };

    let carousel = new EmblaCarousel(viewport, options);

    //
    // Event listeners
    //

    carousel.on('init', (event) => {
      app.embla.onInit(prevBtn, nextBtn, viewport, carousel);
    });

    carousel.on('reInit', (event) => {
      buttons.forEach((button) => {
        button.removeEventListener('click', buttonHandler);
      });

      section.removeAttribute('data-overflow');
      section.removeAttribute('data-initialized');

      carousel.destroy();

      setTimeout(() => {
        initTabsCarousel(section);
      }, 100);
    });

    carousel.on('select', (event) => {
      updateButtons(carousel.selectedScrollSnap());
      app.embla.onSelect(prevBtn, nextBtn, carousel);
    });

    carousel.on('settle', (event) => {
      app.embla.onSettle(carousel);
    });

    //
    // Handle buttons
    //

    buttons.forEach((button) => {
      button.addEventListener('click', buttonHandler);
    });
  }

  // Expose public functions and variables
  return {
    init: init,
    initGeneric: initGeneric,
  };
})();
